import { addHook, Hook } from '@sheerid/jslib';


export const googleTagManagerHook = () => {
    const hookDefinition: Hook = {
        name: 'ON_VERIFICATION_STEP_CHANGE',
        callback(verificationResponse) {
            // window.dataLayer is, and should be, defined within the <head> tags in index.html
            // @ts-ignore
            window.dataLayer.push({
                event: 'step-change',
                'step-name': verificationResponse.currentStep,
                verificationId: verificationResponse.verificationId,
            });
        },
    };
    addHook(hookDefinition);
};
